import React from 'react'
import { Container } from './ReceivementOverviewList.style'
import { PageHeaderAndFilters } from '../components/PageHeaderAndFilters'
import { ReceivementsTable } from '../components/ReceivementsTable'

const ReceivementOverviewList: React.FC = () => (
  <Container>
    <PageHeaderAndFilters />
    <ReceivementsTable />
  </Container>
)

export default ReceivementOverviewList
